module.exports = __webpack_public_path__ + "assets/measure_camera_status.9edfd2e0.svg";